import PublicHeader from "../components/PublicHeader";
import "./css/Contact.css";

export default function ContactPage() {
    return (
        <div className="contact-container">
            <PublicHeader />


            <div className="contact-box">

                <h1>Fale com a nossa equipe</h1>
                <p>Estamos aqui para ajudar você a conhecer e implementar o MesaClick.</p>

                <div className="contact-item">
                    <a className="bi bi-whatsapp" href="https://wa.me/5567999077564" target="_blank"> WhatsApp
                    </a>
                </div>

                <div className="contact-item">
                    <a className="bi bi-envelope contact-icon" href="mailto:contato@faenetech.com.br"> E-mail
                    </a>
                </div>

                <div className="contact-item">

                    <strong className="bi bi-geo-alt contact-icon"> Localização:</strong>
                    <span>Três Lagoas — MS</span>
                </div>

                <div className="contact-item">
                    <strong className="bi bi-clock contact-icon"> Atendimento:</strong>
                    <span>Seg a Sex, das 08h às 18h</span>
                </div>

            </div>
        </div>
    );
}
